import { createUseStyles } from 'react-jss'

import { textEllipsisMultiline } from '../../../../../../styles/mixins/text'
import { lightGrey } from '../../../../../../styles/const/colors'

export const carouselAdThumbnailHeight = 150
const carouselItemWidth = 150
const carouselItemMarginRight = 10

const slide = data => {
  if (!data) return 0
  const { selectedCarouselItemIndex, lastItemIndex } = data

  const carouselItemWidthWithMargin = carouselItemWidth + carouselItemMarginRight

  if (!selectedCarouselItemIndex) {
    return 0
  } else if (selectedCarouselItemIndex === lastItemIndex) {
    return -carouselItemWidthWithMargin * selectedCarouselItemIndex + 72
  } else {
    return -carouselItemWidthWithMargin * selectedCarouselItemIndex + 38
  }
}

export default createUseStyles({
  carouselItem: {
    width: carouselItemWidth,
    minWidth: carouselItemWidth,
    minHeight: 150,
    maxHeight: 185,
    borderRadius: 5,
    border: `1px solid ${lightGrey}`,
    marginRight: carouselItemMarginRight,
    overflow: 'hidden',
    transition: 'all .5s',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',

    '&:first-child': {
      marginLeft: data => slide(data)
    },

    '&:hover': {
      boxShadow: '0 1px 5px 2px rgba(0,0,0,.05)'
    }
  },
  thumbnail: {
    height: carouselAdThumbnailHeight,
    maxHeight: carouselAdThumbnailHeight
  },
  footer: {
    height: 35,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 5px 3px'
  },
  info: {
    width: 85,
    maxWidth: '60%',
    height: '100%',
    position: 'relative'
  },

  // headline
  carouseHeadlineText: {
    fontSize: 8,
    ...textEllipsisMultiline(2),
    position: 'absolute'
  },
  skeletonCarouselHeadline: {
    maxHeight: 7,
    height: 7
  },

  // description
  carouseDescriptionText: {
    fontSize: 7,
    position: 'absolute',
    bottom: 0
  },

  skeletonCarouselDescription: {
    width: 50
  },

  // action button
  carouseActionButton: {
    padding: '0 4px'
  }
})
